<template>
    <b-overlay :show="is_load">
        <div class="categ_info" v-if="cur_item.id > 0">
            <fileload
                @on_load="on_loading_files"
                :doc_id="cur_item.id"
                :open_file="true"
                doc_type="review"
            ></fileload>
        </div>
    </b-overlay>
</template>

<script>
import Fileload from "../../../../sys/file_loader/fileload";

export default {
    name: "review_tab_files",
    props : {
        org : {
            type : Object
        }
    },
    data() {
        return {
            cur_item : this.org,
            is_loaded : false,
            is_load: false,
            my_files : []
        }
    },
    components: {
        Fileload
    },


    created() {

    },

    methods: {
        on_loading_files(state) {
            this.is_load = state;
        }
    },
}
</script>

<style scoped>

</style>
